export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 3_02.0f5fe3a0.jpg";